module.exports = __webpack_public_path__ + "static/media/payer-confirmation.9bdb7e92.svg";